#version 300 es
in vec3 aPos;
in vec3 aNormal;
uniform mat4 uModel;
uniform mat4 uView;
uniform mat4 uProjection;
uniform mat4 uShadowMatrix;
out vec3 vNormal;
out vec3 vWorldPos;
out vec4 vShadowCoord;
void main() {
  vNormal = mat3(uModel) * aNormal;
  vec4 worldPos = uModel * vec4(aPos, 1.0);
  vWorldPos = worldPos.xyz;
  // Transform to shadow map space [0,1] range
  vShadowCoord = uShadowMatrix * worldPos;
  gl_Position = uProjection * uView * worldPos;
}
